// extracted by mini-css-extract-plugin
export var form = "sign-in-module--form--ca8bd";
export var legal = "sign-in-module--legal--ebbda";
export var root = "sign-in-module--root--df24f";
export var sso = "sign-in-module--sso--f7980";